<template>
  <div
    data-component="Peers"
    class="peer-wrapper"
    :style="{
      gridTemplateColumns: getColCountPx,
      gridTemplateRows: getRowCountPx,
      padding: getStagePadding + 'px',
      display: screenPeer != null ? 'flex' : 'grid',
      flex: screenPeer != null ? 'unset' : '1'
    }"
    :class="screenPeer != null ? 'peer-wrapper-screen-cast' : ''"
  >
    <!-- Eğer ekran paylaşımı yok ise bu kısım çalışır -->
    <template v-if="screenPeer != null">
      <div
        class="peer-container"
        style="margin-bottom:10px;"
        :class="screenPeer != null ? 'has-screen-cast' : ''"
        v-if="screenPeer != null"
      >
        <Peer
          :myScreenShare="myScreenShare"
          :peer="screenPeer"
          :screenShare="true"
          :room-client="roomClient"
        />
      </div>

      <div class="screen-cast-bottom-wrapper">
        <transition name="fade" mode="out-in">
         <Me class="peer-container"
          :style="
            'background-image: url(' +
              $imageus +
              mee.image +
              '); background-position: center 30%; background-size: cover;'
          "
          :room-client="roomClient"
          :class="{
            'active-speaker': $store.state.statsPeerId === activeSpeakerId
          }"
          v-if="checkPeer($store.state.participant.item.id)"
        />
        </transition>



        <transition
          name="fade"
          mode="out-in"
          v-for="peer in peers"
          :key="peer.id"
        >
          <div
            class="peer-container"
            :style="
              'background-image: url(' +
                $imageus +
                peer.picture +
                '); background-position: center 30%; background-size: cover;'
            "
            :class="{ 'active-speaker': peer.id === activeSpeakerId }"
            v-if="checkPeer(peer.id)"
          >
            <Peer
              :myScreenShare="false"
              :peer="peer"
              :screenShare="false"
              :room-client="roomClient"
            />
          </div>
        </transition>
      </div>
    </template>
    <!-- Eğer ekran paylaşımı var ise bu kısım çalışır, render tipleri farklı -->
    <template v-else>
      <Me
        class="peer-container"
        :style="
          'background-image: url(' +
            $imageus +
            mee.image +
            '); background-position: center 30%; background-size: cover;'
        "
        :room-client="roomClient"
        :class="{
          'active-speaker': $store.state.statsPeerId === activeSpeakerId
        }"
        v-if="checkPeer($store.state.participant.item.id)"
      />

      <transition v-for="peer in peers" :key="peer.id" appear>
        <div
          class="peer-container"
          :style="
            'background-image: url(' +
              $imageus +
              peer.picture +
              '); background-position: center 30%; background-size: cover;'
          "
          :class="{ 'active-speaker': peer.id === activeSpeakerId }"
          v-if="checkPeer(peer.id)"
        >
          <Peer
            :myScreenShare="false"
            :peer="peer"
            :screenShare="false"
            :room-client="roomClient"
          />
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import Peer from "../media/Peer";
import Me from "../media/Me";
import $ from "jquery";

export default {
  components: { Peer, Me },
  props: {
    isPlaying: false,
    roomClient: {
      type: Object,
      required: true
    },
    roomType: null
  },
  data() {
    return {
      screenCast: null,
      myScreenCast: null,
      vote: null,
      stageWidth: 0,
      stageHeight: 0,
      myScreenShare: false
    };
  },
  mounted() {
    this.calcGeneralDims();
    window.addEventListener("resize", () => {
      this.handleResize();
    });

    this.$root.$on("toggleMenu", () => {
      setTimeout(() => {
        this.handleResize();
      }, 300);
    });
  },
  beforeDestroy() {
    this.$root.$off("toggleMenu");
  },
  methods: {
    checkPeer(peerId) {
      return true;
      try {
        //debugger;
        if (this.roomType == "networking") {
          return true;
        }

        return this.$store.state.currentSession.publishers.some(
          x => x.participantID == peerId
        );
      } catch (e) {
        return false;
      }
    },
    handleResize() {
      if (document.getElementById("holacon-session-container") != null) {
        this.calcGeneralDims();
      }
    },
    calcGeneralDims() {
      this.stageWidth = document.getElementById(
        "holacon-session-container"
      ).offsetWidth;
      this.stageHeight =
        document.getElementById("holacon-session-container").offsetHeight - 50;

      this.calcDims();
    },
    calcDims() {
      if (this.screenPeer != null) {
        $(".peer-container").each(function() {
          if ($(this).hasClass("has-screen-cast")) {
            $(this).css("width", "100%");

            if ($(window).width() <= 768) {
              $(this).css("height", window.innerHeight - 55 - 20 - 280);
            }
            else{
$(this).css("height", window.innerHeight - 55 - 20 - 175);
            }


          } else {
            $(this).css("width", "125px");
            $(this).css("height", "125px");
          }
        });
      } else {
        $(".peer-container").css("width", this.getItemSize.width + "px");
        $(".peer-container").css("height", this.getItemSize.height + "px");
      }
    }
  },
  watch: {
    "$store.state.me": function() {
      this.$nextTick(() => {
        this.handleResize();
      });
    },
    "$store.state.peers": function() {
      this.$nextTick(() => {
        this.handleResize();
      });
    },
    "$store.state.consumers": function() {
      this.$nextTick(() => {
        this.handleResize();
      });
    },
    "$store.state.producers": function() {
      this.$nextTick(() => {
        this.handleResize();
      });
    },
    stageWidth: function() {
      this.calcDims();
    },
    stageHeight: function() {
      this.calcDims();
    }
  },
  computed: {
    screenPeer() {
      var consumer = this.$store.state.consumers.find(
        x =>
          x.appData != null &&
          x.appData.share == true &&
          x.appData.source == "screen"
      );
      var meProducer = this.$store.state.producers.find(x => x.type == "share");
      if (meProducer != null) {
        this.myScreenShare = true;
        return this.$store.state.me;
      }

      this.myScreenShare = false;

      if (consumer == null) return null;

      var peer = this.$store.state.peers.find(
        x => x.id == consumer.appData.peerId
      );

      return peer;
    },
    mee() {
      return this.$store.state.me;
    },
    getScreenCastProducer() {
      return this.$store.state.producers.find(x => x.type == "share");
    },
    getCurrentSession() {
      return this.$store.getters.getCurrentSession;
    },
    streamCount() {
      return this.$store.state.peers.filter(x => x.displayName != 'recording').length + 1;
    },
    hasScreenCast() {
      return (
        this.screenCast != null ||
        this.myScreenCast != null ||
        this.vote != null
      );
    },
    getColCount() {
      var c = this.streamCount;

      if ($(window).width() <= 768) {
        if (c == 1) {
          return "1fr";
        }
        if (c > 1) {
          return "1fr 1fr";
        }
      }

      if (c <= 1) {
        return "1fr";
      }
      if (c == 2) {
        return "1fr 1fr";
      }
      if (c == 3) {
        return "1fr 1fr 1fr";
      }
      if (c <= 4) {
        return "1fr 1fr";
      }
      if (c <= 6) {
        return "1fr 1fr 1fr";
      }
      if (c <= 9) {
        return "1fr 1fr 1fr";
      }
      if (c <= 12) {
        return "1fr 1fr 1fr 1fr";
      }
      if (c <= 15) {
        return "1fr 1fr 1fr 1fr 1fr";
      }
       if (c <= 30) {
        return "1fr 1fr 1fr 1fr 1fr 1fr";
      }
      if (c > 30) {
        return "1fr 1fr 1fr 1fr 1fr 1fr 1fr";
      }

      return "1fr";
    },
    getRowCount() {
      var c = this.streamCount;
      if ($(window).width() <= 768) {
        var x = Math.ceil(c / 2);

        x = Array.apply(null, Array(x)).map(function(x, i) {
          return "1fr";
        });
        return x.join(" ");
      }
      if (c <= 3) {
        return "1fr";
      }
      if (c > 3 && c <= 8) {
        return "1fr 1fr";
      }
      if (c > 4 && c <= 8) {
        return "1fr 1fr";
      }
      if (c > 8) {
        return "1fr 1fr 1fr";
      }
      return "1fr";
    },
    getColCountPx() {
      return this.getColCount.replace(
        /1fr/g,
        this.getItemSize.width.toString() + "px"
      );
    },
    getRowCountPx() {
      return this.getRowCount.replace(
        /1fr/g,
        this.getItemSize.height.toString() + "px"
      );
    },
    getSpacing() {
      return 60;
    },
    getStagePadding() {
      if (
        this.myScreenCast != null ||
        this.screenCast != null ||
        this.vote != null
      )
        return 0;
      return 20;
    },
    getItemSize() {
      if (window.innerWidth <= 768) {
        return {
          width: window.innerWidth,
          height: 250
        };
      }

      var x = this.getColCount;
      x = x.split(" ");
      var a = x.length;
      var colCount = a;

      var x = this.getRowCount;
      x = x.split(" ");
      var a = x.length;
      var rowCount = a;

      var size = {
        width:
          (this.stageWidth -
            parseInt(this.getStagePadding.toString().replace("px", "")) * 2.5) /
          colCount,
        height:
          (this.stageHeight -
            parseInt(this.getStagePadding.toString().replace("px", "")) * 2) /
          rowCount
      };

      var w = size.width;
      var h = size.width * 0.70;
      if (size.width >= w && size.height >= h) {
        return {
          width: w - 10,
          height: h - 10
        };
      } else {
        var h = size.height;
        var w = size.height * 1.3;
        return {
          width: w - 10,
          height: h - 10
        };
      }
    },
    getFrameHeight() {
      if (this.hasScreenCast) {
        return 100;
      }
      var x = this.getColCount;
      x = x.split(" ");
      var a = x.length + 1;
      return (this.stageWidth / a) * 0.75;
    },

    peers() {
      return this.$store.state.peers.filter(x => x.displayName != 'recording');
    },
    consumers() {
      return this.$store.state.consumers;
    },
    activeSpeakerId() {
      return this.$store.state.activeSpeakerId;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/media/Peers.vue